// extracted by mini-css-extract-plugin
module.exports = {"pageContent":"styles-module--pageContent--3wyDy"};